import dayjs, { Dayjs, QUnitType } from 'dayjs';

const getTripDiff = (tripStart: string | Dayjs, tripFinish: string | Dayjs, unit: QUnitType = 'hours') =>
  dayjs(tripFinish).diff(tripStart, unit);

export const getDaysLabel = (daysCount: number) => `${daysCount} day${daysCount > 1 ? 's' : ''}`;

export const getDaysCount = (tripStart: string | Dayjs, tripFinish: string | Dayjs) =>
  Math.ceil(getTripDiff(tripStart, tripFinish, 'day') + 1);

export const getBookingDurationLabel = (tripStart: string | Dayjs, tripFinish: string | Dayjs) => {
  const daysCount = getDaysCount(tripStart, tripFinish);
  const hoursCount = getTripDiff(tripStart, tripFinish);

  return hoursCount >= 24 ? getDaysLabel(daysCount) : `${hoursCount} hours`;
};
